
import React, { useState, useEffect } from 'react';
import { Card } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import LineChart from "examples/Charts/LineCharts/LineChart";
import { api } from 'services/api';
import { logger } from 'services/logger';
import { lineChartOptionsDashboard } from "layouts/dashboard/data/lineChartOptions";

const FraudstersOverview = ({ fraudsters }) => {
  const [chartOptions, setChartOptions] = useState(lineChartOptionsDashboard);
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (fraudsters && fraudsters.length > 0) {
      // Verifica se o primeiro item é um objeto com a propriedade 'createdAt'
      const isObjectArray = typeof fraudsters[0] === 'object' && fraudsters[0] !== null && 'createdAt' in fraudsters[0];

      let categories;
      let seriesData;

      if (isObjectArray) {
        // Lógica original se for um array de objetos
        categories = fraudsters.map(item => new Date(item.createdAt).toLocaleDateString());
        seriesData = [{
          name: "Fraudadores",
          data: fraudsters.map(item => item.fraudScore * 100)
        }];
      } else {
        // Nova lógica se for um array de números (ou qualquer outra coisa)
        // Cria categorias genéricas, já que não temos datas
        categories = fraudsters.map((_, index) => `Fraudador ${index + 1}`);
        seriesData = [{
          name: "Score de Fraude",
          // Assume que os próprios itens são os scores
          data: fraudsters.map(score => score * 100) 
        }];
      }

      setChartData(seriesData);

      const finalOptions = {
        ...lineChartOptionsDashboard,
        xaxis: {
          ...lineChartOptionsDashboard.xaxis,
          categories: categories,
          labels: {
            ...lineChartOptionsDashboard.xaxis.labels,
            show: true,
          },
        },
        colors: ["#FFC107", "#E53935"],
        fill: {
          ...lineChartOptionsDashboard.fill,
          colors: ["#FFC107", "#E53935"],
        },
      };
      setChartOptions(finalOptions);
    }
  }, [fraudsters]);

  

  return (
    <Card>
      <VuiBox sx={{ height: "100%" }}>
        <VuiTypography variant="lg" color="white" fontWeight="bold" mb="5px">
          Overview
        </VuiTypography>
        <VuiBox display="flex" alignItems="center" mb="40px">
          <VuiTypography variant="button" color="text" fontWeight="bold">
            Dados dos últimos 5 fraudadores
          </VuiTypography>
        </VuiBox>
        <VuiBox sx={{ height: "310px" }}>
          <LineChart
            lineChartData={chartData}
            lineChartOptions={chartOptions}
          />
        </VuiBox>
      </VuiBox>
    </Card>
  );
};

export default FraudstersOverview;
